import { ref } from 'vue';

import { defineStore } from 'pinia';

export const useLoaderStore = defineStore('loader', () => {
  const hasShownLoader = ref(true);
  const showLoader = () => {
    hasShownLoader.value = true;
  };
  const hideLoader = () => {
    hasShownLoader.value = false;
  };

  return {
    hasShownLoader,
    showLoader,
    hideLoader,
  };
});
